const styles = theme => ({
  scrollWrapper: {
    position: 'relative',
  },
  rootContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    width: '740px',
    height: '52vh',
    overflow: 'auto',
    paddingTop: '6px',
  },
  scrollDownArrow: {
    position: 'absolute',
    bottom: '12px',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 10,
    backgroundColor: '#fff',
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.18)',
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: '#000',
    transition: 'background-color 0.15s',
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
  scrollableContainer: {
    marginRight: '16px',
  },
  header: {
    fontSize: '14px',
    fontWeight: 500,
    fontFamily: 'Inter',
    color: '#000',
    marginLeft: '8px',
  },
  uploadSection: {
    marginTop: theme.spacing(2),
  },
  numberInputContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  numberInputLabel: {
    flex: 1,
    fontSize: '14px',
    fontWeight: 500,
  },
  numberInput: {
    width: '120px',
    '& .MuiInputBase-root': {
      height: '40px',
    },
  },
  inputButton: {
    cursor: 'pointer',
    padding: theme.spacing(0, 1),
    userSelect: 'none',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2),
    gap: theme.spacing(2),
  },
  addButton: {
    minWidth: '150px',
  },
  listContainer: {
    maxHeight: '260px',
    overflow: 'auto',
  },
  aiHelpText: {
    color: theme.palette.text.secondary,
    fontSize: '11px',
    fontWeight: 400,
    fontFamily: 'Inter',
  },
  limitWarning: {
    marginBottom: theme.spacing(2),
    '& .MuiAlert-message': {
      width: '100%',
    },
  },
  creditInfo: {
    marginBottom: theme.spacing(2),
    '& .MuiAlert-message': {
      width: '100%',
    },
  },
})

export default styles
